// ABOUTME: Terms of Service versioning constants for tracking and version management
// ABOUTME: Update this file whenever ToS is modified (see TOS_UPDATE_WORKFLOW.md)

/**
 * Terms of Service Version Configuration
 *
 * VERSIONING CONVENTION (Semantic Versioning):
 * - MAJOR (X.0.0): Breaking changes that require user re-acceptance
 * - MINOR (1.X.0): Material updates that should notify users
 * - PATCH (1.0.X): Minor fixes/clarifications (silent updates)
 *
 * WHEN TO UPDATE:
 * 1. Update version number and effectiveDate in this file
 * 2. Update TermsOfService.js content
 * 3. Create new record in PocketBase tos_versions collection
 * 4. Commit with Jira ticket: "TD3-XXX: ToS vX.X.X - Description #time Xh"
 * 5. Deploy to production
 *
 * RELATED JIRA: TD3-156 (v1.0.0 Production Launch)
 */

export const TOS_CONSTANTS = {
  /**
   * Current ToS version (semantic versioning)
   * Format: "MAJOR.MINOR.PATCH"
   */
  version: "1.0.0",

  /**
   * Effective date of current version
   * Format: "YYYY-MM-DD" (ISO 8601)
   * IMPORTANT: Use fixed date, not dynamic Date()
   */
  effectiveDate: "2025-11-01",

  /**
   * Human-readable label for this version
   * Used in admin panel and documentation
   */
  label: "Production Launch",

  /**
   * Whether this version requires existing users to re-accept
   * - true: Force logout + re-acceptance modal on login
   * - false: Silent update or notification only
   */
  requiresReAcceptance: false,

  /**
   * Brief description of changes in this version
   * Displayed in admin panel and PocketBase tos_versions collection
   */
  changesSummary: "Initial production Terms of Service with LGPD compliance, age restrictions, and AI disclaimers.",

  /**
   * Related Jira ticket ID
   * Format: "TD3-XXX"
   */
  jiraTicketId: "TD3-156"
};

/**
 * Version History (for quick reference)
 * See TOS_UPDATE_WORKFLOW.md for complete history
 *
 * v1.0.0 (2025-11-01) - TD3-156 - Production Launch
 *   - Initial production ToS (replaced placeholder)
 *   - LGPD compliance sections
 *   - 18+ age restriction
 *   - AI-generated content disclaimers
 *   - Emergency resources
 */

export default TOS_CONSTANTS;
